export const LISTING_TYPE_OPTIONS = [
  {
    id: 'wedding',
    label: 'Pre-Owned Wedding & Occasion Wear',
    title: 'Pre-Owned Wedding & Occasion Wear',
    description:
      'Wedding dresses, bridesmaids, soiree/evening occasion wear, groom, and wedding accessories',
    path: '/create-item?group=wedding',
  },
  {
    id: 'usable',
    label: 'Pre-Owned Curated Finds',
    title: 'Pre-Owned Curated Finds',
    description: 'Everyday pre-owned and luxury pieces — clothes, bags, home goods, and more',
    path: '/create-item',
  },
  {
    id: 'hobbies',
    label: 'Hobbies Finds',
    title: 'Hobbies Finds',
    description: 'Toys, games, arts & crafts, sports, books, and stationary',
    path: '/create-item?group=hobbies',
  },
];

export const SELLER_LISTING_DESTINATIONS = [
  {
    id: 'designers',
    title: 'Designers',
    description: 'Original collections and made-to-order pieces from your brand',
    path: '/create-shop',
  },
  {
    id: 'boutiques',
    title: 'Boutiques',
    description: 'Shop inventory and boutique-branded items',
    path: '/create-boutique',
  },
  {
    id: 'artists',
    title: 'Galleries',
    description: 'Original art and handmade work from your studio',
    path: '/create-shop?kind=artists',
  },
];

export function resolveListingTypeId({
  weddingPreLovedMode,
  luxuryPieceMode,
  defectedDefault,
  hobbiesEntryMode,
}) {
  if (weddingPreLovedMode) return 'wedding';
  if (hobbiesEntryMode) return 'hobbies';
  if (luxuryPieceMode) return 'usable';
  if (defectedDefault) return 'defected';
  return 'usable';
}

/** Evening / cocktail / formal dresses belong in Wedding & Occasion Wear, not Clothing. */
export function looksLikeWeddingOccasionClothing(formData = {}) {
  if (formData.category !== 'Clothing') return false;
  const type = String(formData.clothing_type || '');
  const style = String(formData.clothing_style || '');
  if (type === 'Formal Dresses') return true;
  if (['Evening', 'Cocktail'].includes(style)) return true;
  return false;
}
